import styled from 'src/styles/theme';
import { selectButton } from '@components/Modal/ModalComparators/shared/OVGB';
import { ModalTrimStyled } from '../../ModalTrimStyled';

export const ModalTrimStyledOV = styled(ModalTrimStyled)`
    .trims {
        .sections {
            .trim {
                button {
                    ${selectButton}
                }
            }
        }
    }

    .enginesAvailable,
    .stylesAvailable,
    .colors,
    .interiorsAvailable,
    .featuresAvailable {
        .label {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }

        .sections {
            .engines,
            .styles,
            .interiors,
            .features {
                .engine,
                .style,
                .interior,
                .feature {
                    .details {
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    }
                }
            }
        }
    }

    .categories {
        span {
            background: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.black};
            border-color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.h5};

            &.selected,
            &:hover {
                color: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
